<template>
  <div>
    <div class="network-status-header__content">
      <h1 class="network-status-header__title">
        {{ $t('page-name.network-status') }}
      </h1>
    </div>
    <div class="content-wrapper">
      <network-status-header @apply-filters="applyFilters" />
      <app-content class="network-status">
        <div v-if="false" class="d-flex justify-content-end pb-2">
          <b-button variant="primary" @click="goToNetwork">
            {{ $t('network-status.manage-networks') }}
          </b-button>
        </div>
        <network-status-link
          v-if="$hasUserPermission('PER018')"
          @on-click-link="goToReport"
        />
        <network-status-table
          :items="gridItems"
          :currentPage.sync="currentPage"
          :total-rows="totalItems"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-direction.sync="sortDirection"
          :loading="loading"
          @update:currentPage="currentPageChange"
          @sort-changed="sorting($event)"
        />
      </app-content>
    </div>
  </div>
</template>

<script>
import networkStatusService from '@/domain/services/generalPanel/networkStatus';
import NetworkStatusTable from '@/domain/components/generalPanel/networkStatus/NetworkStatusTable';
import NetworkStatusLink from '@/domain/components/generalPanel/networkStatus/NetworkStatusLink';
import StorageManager from '@/services/sessionStorageManager';
import NetworkStatusHeader from '@/domain/components/generalPanel/networkStatus/NetworkStatusHeader';

export default {
  name: 'NetworkStatusComponent',
  components: {
    NetworkStatusHeader,
    NetworkStatusTable,
    NetworkStatusLink,
  },
  data: () => ({
    currentPage: 1,
    perPage: 15,
    totalItems: null,
    sortBy: 'company',
    sortDirection: 'asc',
    loading: false,
    gridItems: [],
    filter: null,
    filterObject: {},
  }),
  methods: {
    currentPageChange() {
      this.getItems();
    },
    sorting() {
      this.getItems();
    },
    async applyFilters({ filter, filterObject }) {
      this.currentPage = 1;
      this.filter = { ...filter };
      this.filterObject = { ...filterObject };

      await this.getItems();

      if (!this.hasItems) {
        this.$pushAlert({
          code: 'MA009',
        });
      }
    },
    async getItems() {
      this.loading = true;
      try {
        this.gridItems = [];
        const requestFilter = this.getRequestFilter();
        const response = await networkStatusService.getList(requestFilter);
        this.gridItems = response.data;
        this.totalItems = response.total;
      } finally {
        this.loading = false;
      }
    },
    getRequestFilter() {
      const sort = {
        [this.sortBy]: this.sortDirection,
      };
      return {
        filter: this.filter,
        page: this.currentPage,
        pageSize: this.perPage,
        sort,
      };
    },
    saveFilterToStorage() {
      const stringifyFilter = JSON.stringify(this.filterObject);
      return StorageManager.setItemWithId(
        'networkStatusFilter',
        stringifyFilter,
      );
    },
    goToReport() {
      const storageKey = this.saveFilterToStorage();
      const routeData = this.$router.resolve({
        name: 'reports.index',
        query: {
          activeTabName: 'network-status-history',
          filter: storageKey,
        },
      });
      window.open(routeData.href, '_blank');
    },
    goToNetwork() {
      const routeData = this.$router.resolve({
        name: 'network-management',
      });
      window.open(routeData.href, '_self');
    },
  },
  computed: {
    hasItems() {
      return (
        this.totalItems > 0 || (this.gridItems && this.gridItems.length > 0)
      );
    },
  },
};
</script>
<style lang="sass" scoped>
.content-wrapper
  margin: 0 3rem 0 3rem
  border: 1px solid #ccc
  border-radius: 0.1rem
.network-status-header
  &__wrapper
    vertical-align: center
    ::v-deep .material-icons-round
      vertical-align: bottom
  &__content
    display: flex
    flex-direction: column
    padding: 25px 40px
    align-items: center
  &__title
    text-transform: uppercase
    width: 100%
    flex-grow: 10
    padding: 0 1rem
::v-deep .app-content__main-content
  padding: 10px 40px
</style>
